import { Button } from 'primereact/button'

export default function BankCard({entity, btn1, btn2}:any) {
  return <div className='viewContainer flex justify-content-between'>
    <p>{entity.companyname}</p>
    <div className='flex h-fit'>
        {btn1 && <Button className={btn1.className} icon={"pi " + btn1.icon} onClick={btn1.onClick} />}
        {btn2 && <Button className={btn2.className} icon={"pi " + btn2.icon} onClick={btn2.onClick} />}
    </div>
    
  </div>
}
